import { getServiceStrings } from './i18n'

export interface SonioxTokenResponse {
  token?: string
  /** Defensive fallback only — the real proxy never returns this field, kept in case a legacy deployment path is hit. */
  apiKey?: string
  /** ISO 8601 datetime string, e.g. `2026-07-02T05:37:53.120034+00:00`. */
  expiresAt?: string
  wsUrl?: string
}

const DEFAULT_AI_PROXY_URL = 'https://ai.dev.brse.ai/v1/ai'

function getAiProxyBaseUrl(): string {
  return (
    (import.meta as { env?: Record<string, string | undefined> }).env?.VITE_AI_PROXY_URL ||
    DEFAULT_AI_PROXY_URL
  ).replace(/\/$/, '')
}

function getSttWsUrl(baseUrl: string): string {
  const url = new URL(`${baseUrl}/ws/stt`)
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:'
  return url.toString()
}

export async function fetchSonioxToken(): Promise<SonioxTokenResponse> {
  try {
    const baseUrl = getAiProxyBaseUrl()
    const response = await fetch(`${baseUrl}/stt-token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId: `ai-meeting-${Date.now()}` }),
    })
    const data = (await response.json()) as {
      token?: string
      apiKey?: string
      api_key?: string
      expiresAt?: string
      wsUrl?: string
    }
    const token = data.token ?? data.apiKey ?? data.api_key

    if (!response.ok || !token) {
      throw new Error(getServiceStrings().sonioxTokenInvalid)
    }

    return {
      apiKey: data.apiKey ?? data.api_key,
      token,
      expiresAt: data.expiresAt,
      wsUrl: data.wsUrl ?? getSttWsUrl(baseUrl),
    }
  } catch (error) {
    if (error instanceof Error) {
      throw error
    }
    throw new Error(getServiceStrings().sonioxTokenFailed)
  }
}
